import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Field } from "../../../environments/field";
import { environment } from "../.././../environments/environment";
import { apis } from "../../../environments/apis";
// import { UserService } from '../../services/user.service';
import { CrudService } from "../../../environments/crud.service";
import { setForm } from "../../../environments/set_form";
import { from } from "rxjs";

import * as forms from "../form/forms/index";
// Tabla
import {
  ColumnMode,
  DatatableComponent,
  SelectionType,
} from "@swimlane/ngx-datatable";
// Moneda en input
import { CommonModule, CurrencyPipe } from "@angular/common";
// import swal from'sweetalert2';
// import { NotificationsService, NotificationType } from 'angular2-notifications';
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import swal from "sweetalert2";
import {} from "@tinymce/tinymce-angular";
@Component({
  selector: "app-formulario",
  templateUrl: "./formulario.component.html",
  providers: [CrudService],
  styleUrls: ["./formulario.component.css"],
})
export class FormularioComponent implements OnInit {
  public initTiny = {
    language: "es",
    height: 350,
    menubar: false,
    plugins: [
      "advlist autolink lists link image charmap print",
      "preview anchor searchreplace visualblocks code",
      "fullscreen insertdatetime media table paste",
      "help wordcount",
    ],
    toolbar:
      "undo redo | formatselect | bold italic | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | link image | fullscreen | help",
    image_title: true,
    images_upload_handler: this.example_image_upload_handler,
    images_upload_credentials: true,
    file_picker_types: "image",
  };

  @ViewChild("guardarperfil") modal: TemplateRef<any>;
  public modalRef: BsModalRef;
  public usuario = parseInt(JSON.parse(sessionStorage.getItem("usuario")).id);
  public color_encabezados = "#E3E3E3";
  public color_conceptos = "#E3E3E3";
  public data = {};
  public url = environment.apiUrl;
  public proyecto = sessionStorage.getItem("proyecto");
  // Secciones
  public listfields: Array<any>;
  public page_title: string;
  public page_description: string;
  public token = sessionStorage.getItem("token");
  public identity;
  public status: { status: boolean; error?: any };

  public create_edit;
  public classwidthfields;
  public fields: Array<Field>;
  @Input() id;
  @Input() seccion: string;
  @Input() areas: boolean;
  @Input() saved: boolean;
  @Output() savedFuncion = new EventEmitter();
  @Output() idFuncion = new EventEmitter();

  @Input() atras: string;
  @Input() agregar: boolean;
  public atras_table: Array<any>;

  public fieldsexclude: Array<any>;
  // Configuracion de tabla
  public idtable: string;
  public counttable: number = 0;
  public ColumnMode = ColumnMode;

  public number_of_table: number = 0;
  public exists_table: boolean = false;
  public exists_table_required: boolean = false;
  public exists_rows: boolean = false;
  public exists_multiselect: boolean = false;
  public real_url: string;
  // Moneda
  formattedAmount;

  //Con areas
  public con_areas = ["series"];
  // Api query
  public api: string;
  public area: string;
  public href: Array<any> = [];
  @Input() preview: boolean;
  public tipo_de_proyecto = sessionStorage.getItem("tipo_de_proyecto");
  public tipo_de_area = sessionStorage.getItem("tipo_de_area");
  public tipo_de_usuario = sessionStorage.getItem("tipo_de_usuario");

  public pago = sessionStorage.getItem("pago");
  public validacion = sessionStorage.getItem("validacion");

  // private _userService: UserService,
  constructor(
    private route: ActivatedRoute,
    private _crudService: CrudService,
    private router: Router,
    // private notifications: NotificationsService,
    private currencyPipe: CurrencyPipe,
    private modalService: BsModalService
  ) {
    this.token = sessionStorage.getItem("token");

    // Es el tamaño por defecto de los campos a los que no se les asigno un tamaño(width)
    this.classwidthfields = "col-md-6";
    // Son los tipos de campos que no son de tipo input pero existe un componente para ellos
    this.fieldsexclude = [
      "label",
      "richtext",
      "textarea",
      "file",
      "multiple_file",
      "select",
      "multiselect",
      "button",
      "table",
      "tags",
      "checkbox",
      "money",
      "number",
      "dynamic",
      "dynamicth",
      "table-color",
    ];
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      // this._crudService.getData('perfiles/'+this.usuario, this.token).subscribe(
      //   response => {
      //     this.pago = response.data.pago;
      //     this.validacion = response.data.validacion;
      //     sessionStorage.setItem('tipo', response.data.tipo)
      //     sessionStorage.setItem('pago', response.data.pago)
      //     sessionStorage.setItem('validacion', response.data.validacion)
      //     sessionStorage.setItem('grupo', response.data.grupo)
      //     if(!this.pago && !this.validacion && params.seccion != "perfiles"){
      //       this.router.navigate(['/'])
      //     }

      //   }
      // )
      // this.color_conceptos = "#E3E3E3"
      // this.color_encabezados = "#E3E3E3"
      this.href = this.router.url.split("/");
      if (this.href[1] == "preview") {
        this.preview = true;
      }
      this.real_url = params.seccion;
    });
    if (this.agregar) {
      this.saved = true;
    }

    if (!this.atras) {
      this.atras = this.seccion;
    }

    if (localStorage.getItem("atras")) {
      this.atras_table = ("datos/" + localStorage.getItem("atras")).split("/");
      this.atras_table.unshift("/");
    }
    this.fields = forms[this.seccion];
    if (this.id) {
      if (!localStorage.getItem("atras")) {
        localStorage.setItem("id_parent", this.id);
      }
      // Se realiza la peticion
      this._crudService
        .getData(apis[this.seccion] + "/" + this.id, this.token, {
          proyecto: this.proyecto,
          is_admin: true,
        })
        .subscribe((response) => {
          for (let field in this.fields) {
            // Se verifica si el resultado es de tipo moneda
            if (
              (this.fields[field].type === "number" ||
                this.fields[field].type === "money") &&
              response.data[this.fields[field].name]
            ) {
              this.fields[field].value = this.currencyPipe
                .transform(response.data[this.fields[field].name], "")
                .replace(/\$/g, "");
            } else {
              if (this.fields[field].type != "hidden") {
                this.fields[field].value =
                  response.data[this.fields[field].name];
              }
            }
            if (this.fields[field].type != "hidden") {
              this.data[this.fields[field].name] = this.fields[field].value;
            }
            // Se verifica si es un multiselect
            if (
              this.fields[field].type == "select" ||
              this.fields[field].type == "multiselect"
            ) {
              let form = "";

              if (this.fields[field].name in response.data) {
                if (response.data[this.fields[field].name.replace("_id", "")]) {
                  if (this.fields[field].type == "multiselect") {
                    this.fields[field].value =
                      response.data[this.fields[field].name];
                  } else {
                    this.fields[field].value =
                      response.data[this.fields[field].name];
                    // console.log("this.fields[field].value", this.fields[field].value);
                  }
                }
              }
              if (this.fields[field].api) {
                let id = "";
                if (localStorage.getItem("id_parent")) {
                  id = localStorage.getItem("id_parent");
                }

                let data = {
                  proyecto: this.proyecto,
                  id: id,
                  options: true,
                  seccion: this.seccion,
                };
                if (this.seccion == "almacenistas" && this.fields[field].name == "av") {
                  let ofv = ''
                  for(let field of this.fields){
                    if(field.name == "ofv"){
                      ofv = field.value;
                    }
                  }
                  data["id"] = ofv;
                }
                this._crudService
                  .getData(this.fields[field].api, this.token, data)
                  .subscribe((response) => {
                    this.fields[field].options = [];
                    for (let data of response.data) {
                      this.fields[field].options.push({
                        value: data.id,
                        text: data.name
                          ? data.name
                          : data.nombre_del_cliente
                          ? data.nombre_del_cliente
                          : data.puesto
                          ? data.puesto
                          : data.concepto
                          ? data.concepto
                          : data.title
                          ? data.title
                          : data.nombre
                          ? data.nombre
                          : data.ciclo
                          ? data.year +
                            " " +
                            data.abarca +
                            " (" +
                            data.ciclo +
                            ")"
                          : data.opcion
                          ? data.opcion
                          : data.pregunta
                          ? data.pregunta
                          : data.institucion
                          ? data.institucion
                          : "",
                      });
                    }
                  });
              } else {
                this.fields[field].value =
                  response.data[this.fields[field].name];
                form = this.fields[field].value;
                for (let field of this.fields) {
                  if (
                    form == "OPCIONES" &&
                    (field.classfield == "addtable" ||
                      field.classfield == "tableadd")
                  ) {
                    field.hidden = false;
                  } else if (
                    form == "OPCIONES" &&
                    (field.classfield == "addtable2" ||
                      field.classfield == "tableadd2")
                  ) {
                    field.hidden = true;
                  }
                  if (
                    form == "MATRIZ" &&
                    (field.classfield == "addtable" ||
                      field.classfield == "addtable2" ||
                      field.classfield == "tableadd" ||
                      field.classfield == "tableadd2")
                  ) {
                    field.hidden = false;
                  } else if (
                    (form == "ABIERTAS" ||
                      form == "ESCALA" ||
                      form == "SATISFACCION") &&
                    (field.classfield == "addtable" ||
                      field.classfield == "addtable2" ||
                      field.classfield == "tableadd" ||
                      field.classfield == "tableadd2")
                  ) {
                    field.hidden = true;
                  }
                }
              }
            }

            // Verifica si es dynamic
            if (this.fields[field].type == "dynamic") {
              this._crudService
                .getData(this.fields[field].api, this.token, {
                  proyecto: this.proyecto,
                  is_admin: true,
                  id_parent: this.id,
                })
                .subscribe((response) => {
                  this.fields[field].rows = [];
                  for (let data of response.data) {
                    this.fields[field].rows.push({
                      name: "field" + data.id,
                      label: data.label,
                      value: data.valor,
                    });
                  }
                });
            }
            if (this.fields[field].type == "dynamicth") {
              this._crudService
                .getData(this.fields[field].api, this.token, {
                  proyecto: this.proyecto,
                  is_admin: true,
                  id_parent: this.id,
                  th: true,
                })
                .subscribe((response) => {
                  this.fields[field].rows = [];
                  for (let data of response.data) {
                    this.fields[field].rows.push({
                      name: "field" + data.id,
                      namedos: "fielddos" + data.id,
                      label: data.label,
                      value: data.valor,
                      valuedos: data.valordos,
                    });
                  }
                });
            }

            // Se verifica si es una tabla

            if (this.fields[field].type == "table") {
              this.fields[field].rows = [];

              let data = {
                data: this.id,
                tipo: this.fields[field].area,
                proyecto: this.proyecto,
                options: true,
              };
              if (localStorage.getItem("id_parent")) {
                data["id_parent"] = localStorage.getItem("id_parent");
              }
              this._crudService
                .getData(this.fields[field].api, this.token, data)
                .subscribe((response) => {
                  this.counttable = 0;
                  for (let data of response.data) {
                    let obj = {
                      acciones: this.counttable,
                    };
                    this.counttable += 1;
                    for (let row in data) {
                      obj[row] = data[row];
                    }
                    this.fields[field].rows.push(obj);
                    this.fields[field].rows = [...this.fields[field].rows];
                  }
                  console.log(this.fields[field].rows);
                });
            }

            if (this.fields[field].external) {
              this._crudService
                .getTable(
                  this.token,
                  this.seccion,
                  this.id,
                  this.fields[field].api
                )
                .subscribe((response) => {
                  if (Array.isArray(response)) {
                    for (let data of response) {
                      this.fields[field].value = data.description
                        ? data.description
                        : data.name
                        ? data.name
                        : data.content
                        ? data.content
                        : data;
                    }
                  } else {
                    this.fields[field].value = response;
                  }
                });
            }
            if (this.fields[field].type == "table-color") {
              this.color_conceptos = response.data["color_tablas"];
              this.color_encabezados = response.data["color_encabezados"];
            }

            if (this.fields[field].type == "file") {
              this.fields[field].file_config.headers["Authorization"] =
                "Token " + this.token;
            }
          }
        });
    } else {
      for (let field in this.fields) {
        if (this.fields[field].type != "hidden") {
          this.fields[field].value = "";
        }
        this.fields[field].rows = [];
        if (
          this.fields[field].type == "select" ||
          this.fields[field].type == "multiselect"
        ) {
          let id = "";
          if (localStorage.getItem("id_parent")) {
            id = localStorage.getItem("id_parent");
          }
          this._crudService
            .getData(this.fields[field].api, this.token, {
              proyecto: this.proyecto,
              is_admin: true,
              id: id,
              options: true,
              seccion: this.seccion,
            })
            .subscribe((response) => {
              this.fields[field].value = [];
              this.fields[field].options = [];
              for (let data of response.data) {
                this.fields[field].options.push({
                  value: data.id,
                  text: data.name
                    ? data.name
                    : data.nombre_del_cliente
                    ? data.nombre_del_cliente
                    : data.puesto
                    ? data.puesto
                    : data.concepto
                    ? data.concepto
                    : data.title
                    ? data.title
                    : data.nombre
                    ? data.nombre
                    : data.ciclo
                    ? data.year + " " + data.abarca + " (" + data.ciclo + ")"
                    : data.pregunta
                    ? data.pregunta
                    : data.institucion
                    ? data.institucion
                    : "",
                });
              }
            });
        }
        // Verifica si es dynamic
        if (this.fields[field].type == "dynamic") {
          this._crudService
            .getData(this.fields[field].api, this.token, {
              proyecto: this.proyecto,
              is_admin: true,
              id_parent: this.id,
            })
            .subscribe((response) => {
              this.fields[field].rows = [];
              for (let data of response.data) {
                this.fields[field].rows.push({
                  name: "field" + data.id,
                  label: data.label,
                  value: data.valor,
                });
              }
            });
        }

        if (this.fields[field].type == "dynamicth") {
          this._crudService
            .getData(this.fields[field].api, this.token, {
              proyecto: this.proyecto,
              is_admin: true,
              id_parent: this.id,
              th: true,
            })
            .subscribe((response) => {
              this.fields[field].rows = [];
              for (let data of response.data) {
                this.fields[field].rows.push({
                  name: "field" + data.id,
                  namedos: "fielddos" + data.id,
                  label: data.label,
                  value: data.valor,
                  valuedos: data.valordos,
                });
              }
            });
        }

        if (this.fields[field].type == "file") {
          this.fields[field].file_config.headers["Authorization"] =
            "Token " + this.token;
        }
      }
    }
  }

  onSubmit(form) {
    this.number_of_table = 0;
    if (!this.areas || this.saved) {
      let controls = form.controls;
      for (let control in form.controls) {
        this.data[control] = controls[control].value;
      }
      this.api = this.seccion;
      for (let field of this.fields) {
        if (field.is_table) {
          if (field.type == "table") {
            this.exists_table = true;

            if (field.required) {
              this.exists_table_required = true;
            }
            if (field.rows.length > 0) {
              this.exists_rows = true;
              this.number_of_table += 1;
            }
          }
        }
      }
      // Seccion de guardar
      if (!this.id) {
        this.data["proyecto"] = this.proyecto;
        // Solo tablas
        if (
          (this.exists_table && this.exists_rows) ||
          this.exists_table_required
        ) {
          let data_tables = {};
          let forloop = 0;
          for (let field of this.fields) {
            if (field.type == "table") {
              if (field.rows.length == 0 && field.required && !field.hidden) {
                swal.fire(
                  "¡Oops!",
                  "asegurate de haber agregado por lo menos una fila a la tabla",
                  "error"
                );
              }
              let contador = 0;
              let field_name = field.name;
              data_tables[field_name] = [];
              for (let data of field.rows) {
                // data['proyecto'] = this.proyecto;
                data["is_admin"] = true;
                data["options"] = true;
                this._crudService
                  .postData(apis[field.api] + "/", this.token, data)
                  .subscribe((response) => {
                    data_tables[field_name].push(response.id);
                    contador++;
                    if (field.rows.length == contador) {
                      forloop += 1;
                      if (localStorage.getItem("id_parent")) {
                        this.data["id_parent"] =
                          localStorage.getItem("id_parent");
                      }
                      this.data[field_name] = data_tables[field_name];
                      if (this.number_of_table == forloop) {
                        this._crudService
                          .postData(apis[this.api] + "/", this.token, this.data)
                          .subscribe(
                            (response) => {
                              swal.fire(
                                "Genial!",
                                "Ha guardado los datos correctamente",
                                "success"
                              );
                              // console.log("form", form);
                              for (let field of this.fields) {
                                field.value = "";
                                this.data = {};
                                field.rows = [];
                              }
                              forloop = 0;
                            },
                            (error) => {
                              let alert = "";
                              for (let e in error.error) {
                                let ex = false;
                                for (let field of this.fields) {
                                  if (e == field.name) {
                                    alert +=
                                      field.label +
                                      ": " +
                                      error.error[e] +
                                      "<br>";
                                    ex = true;
                                  }
                                }
                                if (ex == false) {
                                  alert += e + ": " + error.error[e] + "<br>";
                                }
                              }
                              swal.fire("¡Oops!", alert, "error");
                            }
                          );
                      }
                    }
                  });
              }
            }
          }
        }
        // Sin tablas
        else {
          if (localStorage.getItem("id_parent")) {
            this.data["id_parent"] = localStorage.getItem("id_parent");
          }
          this.data["is_admin"] = true;
          this._crudService
            .postData(apis[this.api] + "/", this.token, this.data)
            .subscribe(
              (response) => {
                if (this.seccion == "procesos_data") {
                  for (let field of this.fields) {
                    if (field.type == "select" || field.type == "multiselect") {
                      let id = "";
                      if (localStorage.getItem("id_parent")) {
                        id = localStorage.getItem("id_parent");
                      }
                      this._crudService
                        .getData(field.api, this.token, {
                          proyecto: this.proyecto,
                          is_admin: true,
                          id: id,
                          options: true,
                        })
                        .subscribe((response) => {
                          field.options = [];
                          for (let data of response.data) {
                            field.options.push({
                              value: data.id,
                              text: data.name
                                ? data.name
                                : data.nombre_del_cliente
                                ? data.nombre_del_cliente
                                : data.puesto
                                ? data.puesto
                                : data.concepto
                                ? data.concepto
                                : data.title
                                ? data.title
                                : data.nombre
                                ? data.nombre
                                : data.institucion
                                ? data.institucion
                                : "",
                            });
                          }
                        });
                    }
                  }
                }
                // this.notifications.success('¡Genial!', "Ha guardado los datos correctamente", NotificationType.Bare, {theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
                swal.fire(
                  "Genial!",
                  "Ha guardado los datos correctamente",
                  "success"
                );
                if (!this.areas) {
                  for (let dato of this.fields) {
                    if (dato.type != "hidden") {
                      dato.value = "";
                    }
                  }
                  // form.reset();
                  let botones_remove: Array<HTMLElement> = Array.from(
                    document.querySelectorAll("a.remove")
                  );
                  botones_remove.forEach((element) => element.click());
                  console.log("botones_remove", botones_remove);
                } else {
                  // this.id = response.id
                  if (this.saved) {
                    localStorage.setItem("id_parent", response.data.id);
                  }
                  setTimeout(() => {
                    this.router.navigate([
                      "/datos/" +
                        this.real_url +
                        "/editarpass/" +
                        response.data.id,
                    ]);
                  }, 2000);

                  // this.router.navigate(["/datos/"+this.seccion+"/editar/"+response.id]);
                }
                // console.log(this.data)
                for (let dato of this.fields) {
                  this.data[dato.name] = dato.value;
                }
                // console.log(this.data)
                this.savedFuncion.emit();
                this.idFuncion.emit(response.id);
                if (this.id && !this.areas) {
                  // setTimeout(function(){
                  //   this.router.navigate(["/datos/"+this.atras]);
                  // }, 3000)
                }
                if (this.seccion == "proyectos") {
                  sessionStorage.setItem("proyecto", response.id);
                  sessionStorage.setItem("tipo_de_area", response.tipo_de_area);
                  sessionStorage.setItem(
                    "tipo_de_proyecto",
                    response.tipo_de_proyecto
                  );
                  window.location.replace("/app/avance");
                }
                let element: HTMLElement = document.getElementsByClassName(
                  "dz-remove"
                )[0] as HTMLElement;
                element.click();
              },
              (error) => {
                let alert = "";
                for (let e in error.error) {
                  let ex = false;
                  for (let field of this.fields) {
                    if (e == field.name) {
                      alert += field.label + ": " + error.error[e] + "<br>";
                      ex = true;
                    }
                  }
                  if (ex == false) {
                    alert += e + ": " + error.error[e] + "<br>";
                  }
                }
                swal.fire("¡Oops!", alert, "error");
                // this.notifications.warn('¡Oops!', alert, NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
              }
            );
        }
      }
      // Seccion de actualizar
      else {
        this.data["proyecto"] = this.proyecto;
        if (localStorage.getItem("id_parent")) {
          this.data["id_parent"] = localStorage.getItem("id_parent");
        }
        // Solo si existe tabla
        if (
          (this.exists_table && this.exists_rows) ||
          this.exists_table_required
        ) {
          let data_tables = {};
          let forloop = 0;
          for (let field of this.fields) {
            if (field.type == "table") {
              if (field.rows.length == 0 && field.required && !field.hidden) {
                swal.fire(
                  "¡Oops!",
                  "asegurate de haber agregado por lo menos una fila a la tabla"
                );
              }
              let contador = 0;
              let field_name = field.name;
              data_tables[field_name] = [];
              for (let data of field.rows) {
                // data['proyecto'] = this.proyecto;
                data["is_admin"] = true;
                data["options"] = true;
                this._crudService
                  .postData(apis[field.api] + "/", this.token, data)
                  .subscribe((response) => {
                    data_tables[field_name].push(response.id);
                    contador++;
                    if (field.rows.length == contador) {
                      forloop += 1;
                      if (localStorage.getItem("id_parent")) {
                        this.data["id_parent"] =
                          localStorage.getItem("id_parent");
                      }
                      this.data[field_name] = data_tables[field_name];
                      if (this.number_of_table == forloop) {
                        this._crudService
                          .putData(
                            apis[this.seccion] + "/" + this.id + "/",
                            this.token,
                            this.data
                          )
                          .subscribe(
                            (response) => {
                              swal.fire(
                                "Genial!",
                                "Ha guardado los datos correctamente",
                                "success"
                              );
                              // console.log("form", form);
                              forloop = 0;
                            },
                            (error) => {
                              let alert = "";
                              for (let e in error.error) {
                                let ex = false;
                                for (let field of this.fields) {
                                  if (e == field.name) {
                                    alert +=
                                      field.label +
                                      ": " +
                                      error.error[e] +
                                      "<br>";
                                    ex = true;
                                  }
                                }
                                if (ex == false) {
                                  alert += e + ": " + error.error[e] + "<br>";
                                }
                              }
                              swal.fire("¡Oops!", alert, "error");
                            }
                          );
                      }
                    }
                  });
              }
            }
          }
        } else {
          this.data["is_admin"] = true;
          if (this.seccion != "perfiles") {
            this._crudService
              .putData(
                apis[this.seccion] + "/" + this.id + "/",
                this.token,
                this.data
              )
              .subscribe(
                (response) => {
                  for (let key in response) {
                    if (
                      typeof response[key] == "string" &&
                      response[key].includes("media/")
                    ) {
                      for (let field of this.fields) {
                        if (field.name == key) {
                          field.value = response[key];
                        }
                      }
                    }
                  }
                  let botones_remove: Array<HTMLElement> = Array.from(
                    document.querySelectorAll("a.remove")
                  );
                  botones_remove.forEach((element) => element.click());

                  swal.fire(
                    "Genial!",
                    "Ha actualizado los datos correctamente",
                    "success"
                  );
                  // this.notifications.success('¡Genial!', "Ha sido actualizado correctamente", NotificationType.Bare, {theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
                  if (!this.id) {
                    form.reset();
                  }
                  if (this.seccion == "proyecto") {
                    sessionStorage.setItem(
                      "tipo_de_area",
                      response.tipo_de_area
                    );
                    sessionStorage.setItem(
                      "tipo_de_proyecto",
                      response.tipo_de_proyecto
                    );
                    window.location.reload();
                  }
                  // this.router.navigate(["/datos/"+this.real_url+"/pass/"+this.id]);

                  // this.data = {};
                },
                (error) => {
                  console.log(<any>error);
                  let alert = "";
                  for (let e in error.error) {
                    let ex = false;
                    for (let field of this.fields) {
                      if (e == field.name) {
                        alert += field.label + ": " + error.error[e] + "<br>";
                        ex = true;
                      }
                    }
                    if (ex == false) {
                      alert += e + ": " + error.error[e] + "<br>";
                    }
                  }
                  swal.fire("¡Oops!", alert, "error");
                  // this.notifications.warn('¡Oops!', alert, NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
                }
              );
          } else {
            this.openModal(this.modal);
          }
        }
      }
    } else {
      swal.fire(
        "¡Oops!",
        "Verifica que hayas guardado los datos de la seccion principal",
        "error"
      );
      // this.notifications.warn('¡Oops!', "Verifica que hayas guardado en la sección principal", NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
    }
  }

  formChanged(i, validfield) {
    this.fields[i].validfield = validfield;
    // alert(this.fields[i].name )
    // if(this.fields[i].name == "codigo_postal"){
    //   alert()
    //   this._crudService.getApi('https://api.copomex.com/query/info_cp/'+this.fields[i].value +'?token=pruebas', '').subscribe(
    //     response => {
    //       console.log(response)
    //     }
    //   )
    // }
  }

  onUploadError(event) {
    console.log(event);
  }

  onUploadSuccess(event) {
    let image = event[1].image;
    console.log("event", event);
    let name = event[1].name;
    let url = event[1].url;
    this.data[name] = url.substring(1);
  }

  onReady(editor) {
    editor.ui
      .getEditableElement()
      .parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      );
  }

  // addTable(table, attr){
  // console.log("attr", attr);
  // console.log("table", table);

  //   for(let f of this.fields){
  //   console.log("f", f.columns);

  //     if(f.type == "table"){

  //       if(f.classfield.includes(table)){
  //         let obj = {acciones:this.counttable}
  //         this.counttable += 1;
  //         let contador = 0
  //         for(let id of attr){

  //           for(let field of this.fields){
  //             if(field.name == id){
  //               obj[id] = field.value
  //             }
  //           }

  //           // element.value = ""
  //           if (contador == 0){
  //             // element.focus()
  //             contador++;
  //           }

  //         }
  //         f.rows.push(obj)
  //         f.rows = [...f.rows];

  //       }

  //     }
  //   }
  // }
  addTable(cinpu, table, attr) {
    for (let f of this.fields) {
      if (f.type == "table") {
        if (f.classfield == table) {
          let obj = { acciones: this.counttable };
          this.counttable += 1;
          let contador = 0;
          for (let id of attr) {
            let element: any = document.getElementById(id);
            for (let f of this.fields) {
              if (f.name == id.replace("Table", "")) {
                if (f.type == "select" && f.principal) {
                  for (let opcion of f.options) {
                    if (opcion.value == f.value) {
                      obj[id.replace("Table", "")] = opcion.text;
                      obj["id"] = f.value;
                    }
                  }
                } else {
                  if (f.value != "") {
                    obj[id.replace("Table", "")] = f.value;
                    f.value = "";
                  } else {
                    swal.fire(
                      "¡Oops!",
                      "No puedes agregar datos nulos",
                      "error"
                    );
                    return true;
                  }
                }
              }
            }
            // console.log(obj)
            element.value = "";
            if (contador == 0) {
              element.focus();
              contador++;
            }
          }
          f.rows.push(obj);
          console.log("obj", obj);
          f.rows = [...f.rows];
        }
      }
    }
  }

  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (
        arr[i] &&
        arr[i].hasOwnProperty(attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }

  // eliminar de Tabla
  // Eliminar
  removeTable(id, table) {
    this.idtable = id;
    for (let f of this.fields) {
      if (f.type == "table") {
        if (f.classfield.includes(table)) {
          this.removeByAttr(f.rows, "acciones", id);
          f.rows = [...f.rows];
        }
      }
    }
    console.log(this.idtable);
  }

  // Tags
  addTagFn(addedName) {
    return { name: addedName, tag: true };
  }

  // COnvertir a moneda
  transformAmount(element, name) {
    console.log(Number(element.value));

    element.value = element.value.replace(/\$/g, "").replace(/\,/g, "");

    if (Number(element.value)) {
      for (let field of this.fields) {
        if (field.name == name) {
          field.value = this.currencyPipe.transform(element.value, "");
        }
      }
    }
  }
  transformNumber(element, name) {
    element.value = element.value.replace(/\$/g, "").replace(/\,/g, "");

    if (Number(element.value)) {
      for (let field of this.fields) {
        if (field.name == name) {
          field.value = this.currencyPipe
            .transform(element.value, "")
            .replace(/\$/g, "");
        }
      }
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(this.modal, { class: "modal-sm" });
  }

  confirm(): void {
    this._crudService
      .putData(apis[this.seccion] + "/" + this.id, this.token, this.data)
      .subscribe(
        (response) => {
          swal.fire(
            "Genial!",
            "Ha actualizado los datos correctamente",
            "success"
          );
          // this.notifications.success('¡Genial!', "Ha sido actualizado correctamente", NotificationType.Bare, {theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
          // alert("/datos/perfiles/pass/"+this.id)
          setTimeout(() => {
            // window.location.reload();
            this.router.navigate(["/app"]);
          }, 2000);

          // this.router.navigate(["/datos/perfiles/editarpass/"+this.id]);

          // this.data = {};
        },
        (error) => {
          console.log(<any>error);
          let alert = "";
          for (let e in error.error) {
            alert += e + ": " + error.error[e] + "<br>";
          }
          swal.fire("¡Oops!", alert, "error");
          // this.notifications.warn('¡Oops!', alert, NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
        }
      );
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }

  changeTipo(form, name) {
    if (name == "ofv") {
      this._crudService
        .getData("area_de_ventas", this.token, {
          id: form.value,
          options: true,
        })
        .subscribe(
          (response) => {
            for (let field of this.fields) {
              if (field.name == "av") {
                field.options = []
                for (let dato of response.data) {
                  field.options.push({text: dato.nombre, value: dato.id})
                }
                break;
              }
            }
          },
          (error) => {}
        );
    }
  }

  example_image_upload_handler(blobInfo, success, failure, progress) {
    var xhr, formData;

    xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open("POST", environment.apiUrl + "api/v1/upload/");
    xhr.setRequestHeader(
      "Authorization",
      "Token " + sessionStorage.getItem("token")
    );

    xhr.upload.onprogress = function (e) {
      progress((e.loaded / e.total) * 100);
    };

    xhr.onload = function () {
      var json;

      if (xhr.status === 403) {
        failure("HTTP Error: " + xhr.status, { remove: true });
        return;
      }

      if (xhr.status < 200 || xhr.status >= 300) {
        failure("HTTP Error: " + xhr.status);
        return;
      }

      json = JSON.parse(xhr.responseText);

      if (!json || typeof json.url != "string") {
        failure("Invalid JSON: " + xhr.responseText);
        return;
      }

      success(environment.apiUrl + json.url.substring(1, json.url.length));
    };

    xhr.onerror = function () {
      failure(
        "Image upload failed due to a XHR Transport error. Code: " + xhr.status
      );
    };

    formData = new FormData();
    formData.append("contenido", blobInfo.blob(), blobInfo.filename());

    xhr.send(formData);
  }
}
